
  import React from 'react'
  import { MDXTag } from '@mdx-js/tag'
  import { Playground } from 'docz';
import State from '../../../../docs/State';
import NavBar from '@devsisters/ui-careers/lib/NavBar';

const layoutProps = {
  
};
export default class MDXContent extends React.Component {
  constructor(props) {
    super(props)
    this.layout = null
  }
  render() {
    const { components, ...props } = this.props

    return <MDXTag
             name="wrapper"
             
             components={components}>
<MDXTag name="h1" components={components} props={{"id":"navbar"}}>{`NavBar`}</MDXTag>
<MDXTag name="p" components={components}>{`사이트 상단 네비게이션바 입니다.`}</MDXTag>
<MDXTag name="pre" components={components}><MDXTag name="code" components={components} parentName="pre" props={{"className":"language-tsx"}}>{`import { NavBar } from '@devsisters/ui/careers';
// 또는 import NavBar from '@devsisters/ui-careers/lib/NavBar';
`}</MDXTag></MDXTag>
<MDXTag name="h3" components={components} props={{"id":"놀이터"}}>{`놀이터`}</MDXTag>
<Playground __position={0} __code={'<h1>pc</h1>\n<p>pc 타입은 가로폭 1200px 이상에서 제대로 보입니다.</p>\n<State initialState={{ drawer: false }}>\n  {({ state, setState }) => (\n    <>\n      <NavBar\n        type=\"pc\"\n        links={[\n          { text: \'링크1\', to: \'#link1\' },\n          { text: \'링크2\', to: \'#link2\' },\n          { text: \'링크3\', to: \'#link3\' },\n        ]}\n        outerLinks={[{ text: \'링크4\', to: \'#link4\' }]}\n        currentPath={location.hash}\n        LinkComponent={({ children, to }) => <a href={to}>{children}</a>}\n        drawerOpen={state.drawer}\n        drawerSize={\'100px\'}\n        drawerChildren={<h2>서랍 내용</h2>}\n      />\n      <button onClick={() => setState({ drawer: !state.drawer })}>\n        서랍 {state.drawer ? \'닫기\' : \'열기\'}\n      </button>\n    </>\n  )}\n</State>\n<h1>mobile</h1>\n<State initialState={{ drawer: false }}>\n  {({ state, setState }) => (\n    <>\n      <NavBar\n        type=\"mobile\"\n        mobileMenuStyle={{ zIndex: 10000 }}\n        links={[\n          { text: \'링크1\', to: \'#link1\' },\n          { text: \'링크2\', to: \'#link2\' },\n          { text: \'링크3\', to: \'#link3\' },\n        ]}\n        outerLinks={[{ text: \'링크4\', to: \'#link4\' }]}\n        currentPath=\"/\"\n        LinkComponent={({ children, to }) => <a href={to}>{children}</a>}\n        drawerOpen={state.drawer}\n        drawerSize={\'100px\'}\n        drawerChildren={<h2>서랍 내용</h2>}\n      />\n      <button onClick={() => setState({ drawer: !state.drawer })}>\n        서랍 {state.drawer ? \'닫기\' : \'열기\'}\n      </button>\n    </>\n  )}\n</State>'} __scope={{props: this ? this.props : props,State,NavBar}}>
  <h1>pc</h1>
  <p>pc 타입은 가로폭 1200px 이상에서 제대로 보입니다.</p>
  <State initialState={{ drawer: false }}>
    {({ state, setState }) => <>
      <NavBar
        type='pc'
        links={[
          { text: '링크1', to: '#link1' },
          { text: '링크2', to: '#link2' },
          { text: '링크3', to: '#link3' },
        ]}
        outerLinks={[
          { text: '링크4', to: '#link4' },
        ]}
        currentPath={location.hash}
        LinkComponent={({ children, to }) => <a href={to}>{children}</a>}
        drawerOpen={state.drawer}
        drawerSize={'100px'}
        drawerChildren={<h2>서랍 내용</h2>}
      />
      <button onClick={() => setState({ drawer: !state.drawer })}>
        서랍 { state.drawer ? '닫기' : '열기' }
      </button>
    </>}
  </State>
  <h1>mobile</h1>
  <State initialState={{ drawer: false }}>
    {({ state, setState }) => <>
      <NavBar
        type='mobile'
        mobileMenuStyle={{ zIndex: 10000 }}
        links={[
          { text: '링크1', to: '#link1' },
          { text: '링크2', to: '#link2' },
          { text: '링크3', to: '#link3' },
        ]}
        outerLinks={[
          { text: '링크4', to: '#link4' },
        ]}
        currentPath='/'
        LinkComponent={({ children, to }) => <a href={to}>{children}</a>}
        drawerOpen={state.drawer}
        drawerSize={'100px'}
        drawerChildren={<h2>서랍 내용</h2>}
      />
      <button onClick={() => setState({ drawer: !state.drawer })}>
        서랍 { state.drawer ? '닫기' : '열기' }
      </button>
    </>}
  </State>
</Playground>
           </MDXTag>
  }
}
  